import React from 'react';

import { FILTER_RELATIONS } from '../../../../../../helpers/constants';

import styles from './FiltersRelation.module.css';

export default ({ filterRelation, setFilterRelation }) => {
  const onChangeRelationClick = () => {
    if (filterRelation === FILTER_RELATIONS.AND) {
      setFilterRelation(FILTER_RELATIONS.OR);
    }

    if (filterRelation === FILTER_RELATIONS.OR) {
      setFilterRelation(FILTER_RELATIONS.AND);
    }
  };

  return (
    <div
      className={styles.container}
      role="presentation"
      onClick={onChangeRelationClick}
    >
      {filterRelation}
    </div>
  );
};
